module.exports = __webpack_public_path__ + "assets/img/profile-video.0292a1c2.svg";